"use strict";

import { createSelector } from "reselect";

const prefix = "sidebar";

const EXPAND = `${prefix}/EXPAND`;
const COLLAPSE = `${prefix}/COLLAPSE`;
const TOGGLE = `${prefix}/TOGGLE`;

const SET_HAS_CONTENT = `${prefix}/SET_HAS_CONTENT`;
const SET_NO_CONTENT = `${prefix}/SET_NO_CONTENT`;

export const expand = (id) => ({ type: EXPAND, payload: { id } });
export const collapse = (id) => ({ type: COLLAPSE, payload: { id } });
export const toggle = (id) => ({ type: TOGGLE, payload: { id } });
export const setHasContent = (id) => ({ type: SET_HAS_CONTENT, payload: { id } });
export const setNoContent = (id) => ({ type: SET_NO_CONTENT, payload: { id } });

const baseSelector = (state) => state.sidebar;

export const getIsOpen = createSelector(baseSelector, (state) => state.isOpen);

export const getHasContent = createSelector(baseSelector, (state) => state.hasContent);

const initialState = {
  isOpen: 0,
  hasContent: 0,
};

export default function sidebar(state = initialState, action) {
  switch (action.type) {
    case SET_HAS_CONTENT:
      return {
        ...state,
        hasContent: state.hasContent | action.payload.id,
      };

    case SET_NO_CONTENT:
      return {
        ...state,
        hasContent: state.hasContent ^ action.payload.id,
      };

    case EXPAND:
      return {
        ...state,
        isOpen: state.isOpen | action.payload.id,
      };

    case COLLAPSE:
      return {
        ...state,
        isOpen: state.isOpen ^ action.payload.id,
      };

    case TOGGLE:
      return {
        ...state,
        isOpen: state.isOpen ^ (state.isOpen & action.payload.id),
      };

    default:
      return state;
  }
}
